import { formatISO } from "date-fns";
import translate from "../utils/translate";

/**
 * Retrieves the value of a specified property asynchronously.
 * Will be use to group multiple async call in parallel.
 *
 * @param {Object} property - The property object to retrieve the value from.
 * @returns {Promise<any>} - A promise that resolves with the value of the property.
 */
function getPropertyAsync(property) {
  return new Promise((resolve, reject) => {
    property.getAsync((result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        resolve(result.value);
      } else {
        reject(new Error(result.error.message));
      }
    });
  });
}



async function updateVisitorPortalInvitation(visitorPortalId, invitationId, validFrom, validTo) {
  const apiUrl = process.env.API_URL;

  try {
    const response = await fetch(apiUrl + `/calendar-add-on/invitations/${invitationId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        reservation_valid_from: validFrom,
        reservation_valid_to: validTo,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();

      if (errorData.code === 'validation_error') {
        throw new Error(errorData.error);
      }

      throw new Error(translate('an-error-occurred-please-contact-your-admin'));
    }
  } catch (error) {
    console.error(error);

    throw new Error(error);
  }
}

async function onAppointmentSendHandler(event) {
  Office.context.mailbox.item.body.getAsync("text", { asyncContext: event }, onMeetingSend);
}

async function getCustomProperties() {
  return new Promise((resolve, reject) => {
    Office.context.mailbox.item.loadCustomPropertiesAsync((asyncResult) => {
      if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
        resolve(asyncResult.value);
      } else {
        reject(asyncResult.error);
      }
    });
  });
}

async function onMeetingSend(asyncResult) {
  console.log('Izix calendar invitation update sent.');

  const event = asyncResult.asyncContext;

  const item = Office.context.mailbox.item;

  const appointmentCustomSetting = await getCustomProperties();

  const visitorPortalInvitationId = appointmentCustomSetting.get("visitorPortalInvitationId");
  const visitorPortalId = appointmentCustomSetting.get("visitorPortalId");

  if (!item || !visitorPortalInvitationId || !visitorPortalId) {
    return event.completed({ allowEvent: true });
  }

  try {
    const [startValue, endValue] = await Promise.all([getPropertyAsync(item.start), getPropertyAsync(item.end)]);

    const start = new Date(startValue);
    const end = new Date(endValue);

    await updateVisitorPortalInvitation(
      visitorPortalId,
      visitorPortalInvitationId,
      formatISO(start),
      formatISO(end)
    );
  } catch (error) {
    console.error(error);

    event.completed({
      allowEvent: false,
      errorMessage: error.message
    });
  }

  event.completed({ allowEvent: true });
}

Office.actions.associate("onAppointmentSendHandler", onAppointmentSendHandler);
